import React from 'react';

import Translation from '@swf/components/Translation/Translation';

import { MonthlyRepeat, RecurringDay, WhichRecurringDay, days } from '../utils/utils';

import {
  TXTCLI_first,
  TXTCLI_fourth,
  TXTCLI_last,
  TXTCLI_second,
  TXTCLI_third,
  TXTWCL_On_day,
  TXTWCL_On_the
} from './monthlyOptions.messages.json';

const whichRecurringDayOptions = [
  TXTCLI_first,
  TXTCLI_second,
  TXTCLI_third,
  TXTCLI_fourth,
  TXTCLI_last
].map((day, index) => ({
  text: <Translation {...day} />,
  value: WhichRecurringDay[index]
}));

const recurringDayOptions = days.map(({ translation }, index) => ({
  text: <Translation {...translation} />,
  value: RecurringDay[index]
}));

const monthlyRepeatOptions = [
  { text: <Translation {...TXTWCL_On_day} />, value: MonthlyRepeat.OnDay },
  { text: <Translation {...TXTWCL_On_the} />, value: MonthlyRepeat.OnThe }
];

const dayOptions = [...Array(31).keys()].map((day) => ({
  text: day + 1,
  value: day + 1
}));

export { whichRecurringDayOptions, recurringDayOptions, monthlyRepeatOptions, dayOptions };
